import { createMask } from '../components/phone';
import { Modal } from '../components/modal';
import { Metrika } from '../components/metrika';

export function feedback() {
    const modal = new Modal;
    const metrika = new Metrika;

    let phonesInputs = document.querySelectorAll('[data-phoneMask]');
    phonesInputs.forEach( item => {
        createMask(item)
    });

    let inputs = document.querySelectorAll('[am-input]');
    let formError = document.querySelectorAll('[am-error]');
    inputs.forEach( item => {
        item.addEventListener('input', () => {
            item.classList.remove('error');

            formError.forEach( elem => {
                elem.classList.remove('is-active');
            });
        });
    });

    const forms = document.querySelectorAll('.js-FeedbackForm');

    forms.forEach( form => {
        const type = form.dataset.type;

        // Цели - ввод данных в инпуты
        const inputName = form.querySelector('input[name="fio"]');
        const inputPhone = form.querySelector('input[name="phone"]');

        inputName.addEventListener('change', function() {
            if (type == 'modal') {
                metrika.reachGoal('input_name_in_popup_order', this);
            } else if (type == 'modal_offer') {
                metrika.reachGoal('input_name_in_intro_order', this);
            }
        });

        inputPhone.addEventListener('change', function() {
            if (type == 'modal') {
                metrika.reachGoal('input_phone_in_popup_order', this);
            } else if (type == 'modal_offer') {
                metrika.reachGoal('input_phone_in_intro_order', this);
            }
        });

        form.addEventListener('submit', e => {
            e.preventDefault();
            // От повторных кликов
            const btn = form.querySelector('button');
            btn.setAttribute('disabled', '');

            // Данные для отправки
            const formData = new FormData();
            const fio = form.querySelector('input[name="fio"]').value;
            const phone = form.querySelector('input[name="phone"]').value;
            const comment = form.querySelector('textarea');
            const current_page = document.querySelector('input[name="current_page"]').value;
            const debtAmountBlock = document.querySelector('.variant-block.active-answer text');

            if (debtAmountBlock) {
                const debtAmount = debtAmountBlock.textContent
            }

            if (comment) {
                formData.append('comment', comment.value);
            }

            formData.append('fio', fio);
            formData.append('phone', phone);
            formData.append('current_page', current_page);

            // Отправка
            fetch('/handler/send_feedback ', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
            })
            .then(response => response.json())
            .then(r => {
                btn.removeAttribute('disabled');
                // console.log(r);
                if (r.status == 'ok') {

                    // Цели - отправка формы
                    if (type == 'modal') {
                        metrika.reachGoal('submit_popup_order', form);
                    } else if (type == 'modal_offer') {
                        metrika.reachGoal('submit_intro_order', form);
                    } else if (type == 'modal_help') {
                        metrika.reachGoal('submit_needhelp_order', form);
                    } else if (type == 'modal_question') {
                        metrika.reachGoal('submit_questleft_order', form);
                    }

                    const activeModal = document.querySelector('[am-block="modal"].is-active');

                    if (activeModal) {
                        activeModal.classList.remove('is-active');
                        document.body.style.overflow = '';
                        document.documentElement.style.overflow = '';
                    }

                    modal.open('modal', 'thx', 'close');
                    form.querySelector('input[name="fio"]').value = '';
                    form.querySelector('input[name="phone"]').value = '';
                }

                if (r.status == 'error') {
                    const errorText = form.querySelector('.js-formErrorText');
                    errorText.textContent = r.message;
                    errorText.classList.add('is-active');

                    r.fields.forEach(name => {
                         form.querySelector(`input[name="${name}"]`).classList.add('error');
                    })
                }
            })
        })
    })
}
